import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@chakra-ui/layout";
import React from "react";
import Loader from "../loader";
const PageLoader = ({ height = 250 }) => (_jsx(Box, Object.assign({ mt: "200px" }, { children: _jsx(Loader, { height: height }) })));
export default PageLoader;
